import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

/**
 * Ruta `manage-vehicles/:id/analytics`. Ahora es un contenedor delgado que
 * lee el :id y delega en `app-vehicle-analytics-panel`, el cual consume el
 * FleetMockStore (fuente única de verdad). Se eliminaron los mocks
 * desconectados y el bug de fecha `12/32/2024`.
 */
@Component({
  selector: 'app-vehicle-analytics',
  templateUrl: './vehicle-analytics.component.html',
  styleUrls: ['./vehicle-analytics.component.css'],
})
export class VehicleAnalyticsComponent implements OnInit {
  vehicleId: string | null = null;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
  ) {
    // do nothing
  }

  ngOnInit(): void {
    this.vehicleId = this.route.snapshot.paramMap.get('id');
  }

  goBack(): void {
    this.router.navigate(['/manage-vehicles']);
  }
}
